import { useEffect } from "react";
import { useSite } from "@/context/SiteContext";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!content) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(data) {
  document.head.querySelectorAll("script[data-eb-ld]").forEach((n) => n.remove());
  (data || []).filter(Boolean).forEach((d) => {
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.setAttribute("data-eb-ld", "1");
    s.textContent = JSON.stringify(d);
    document.head.appendChild(s);
  });
}

export function useSeo(pageKey, path, overrides = {}, jsonLd = null) {
  const { site } = useSite() || {};
  const ldKey = JSON.stringify(jsonLd);
  const ovKey = JSON.stringify(overrides);
  useEffect(() => {
    if (!site) return;
    const seo = site.seo || {};
    const page = { ...(seo.pages?.[pageKey] || {}), ...JSON.parse(ovKey) };
    const base = (seo.site_url || "").replace(/\/$/, "");
    const title = page.title || "EditBay by Relatable Studio";
    const ogImage = page.og_image || seo.default_og_image || `${window.location.origin}/brand/og-image.png`;
    document.title = title;
    setMeta("name", "description", page.description);
    setMeta("name", "robots", page.noindex ? "noindex,nofollow" : "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1");
    setMeta("property", "og:site_name", "EditBay by Relatable Studio");
    setMeta("property", "og:title", page.og_title || title);
    setMeta("property", "og:description", page.og_description || page.description);
    setMeta("property", "og:image", ogImage);
    setMeta("property", "og:url", page.canonical || `${base}${path}`);
    setMeta("name", "twitter:image", ogImage);
    setMeta("name", "google-site-verification", seo.google_site_verification);
    setMeta("property", "og:type", "website");
    setMeta("name", "twitter:card", "summary_large_image");
    setLink("canonical", page.canonical || `${base}${path}`);
    setJsonLd(JSON.parse(ldKey));
  }, [site, pageKey, path, ovKey, ldKey]);
}
